export const HOTEL_CONTINENTAL = 'CONTINENTAL';
export const HOTEL_TOWER = 'TOWER';
export const HOTEL_WORLDWIDE = 'WORLDWIDE';
export const HOTEL_AMERICAN = 'AMERICA';
export const HOTEL_LUXOR = 'LUXOR';
export const HOTEL_IMPERIAL = 'IMPERIAL';
export const HOTEL_FESTIVAL = 'FESTIVAL';

export const HOTELS = [
  HOTEL_TOWER,
  HOTEL_LUXOR,
  HOTEL_WORLDWIDE,
  HOTEL_AMERICAN,
  HOTEL_FESTIVAL,
  HOTEL_IMPERIAL,
  HOTEL_CONTINENTAL,
];

export const LOW_HOTEL_PRICES = {
  startingPrice: 200,
  startingMajorityBonus: 2000,
  priceAddend: 100,
  majorityBonusAddend: 1000,
};

export const MID_HOTEL_PRICES = {
  startingPrice: 300,
  startingMajorityBonus: 3000,
  priceAddend: 100,
  majorityBonusAddend: 1000,
};

export const HIGH_HOTEL_PRICES = {
  startingPrice: 400,
  startingMajorityBonus: 4000,
  priceAddend: 100,
  majorityBonusAddend: 1000,
};

export const EDGE_OF_BOARD = 'EDGE_OF_BOARD';
